import styled from 'styled-components';

import { responsive, sp } from '@main/theme';

/**
 * The Panel Wrapper
 */
export const PanelWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  gap: ${sp(2)};
`;

/**
 * The ActionButton Wrapper
 */
export const ActionButtonWrapper = styled.div`
  flex: 0 0 300px;
  max-width: 300px;
  /* Removing fixed height so that align-items: stretch in the parent makes all items equal-height */
  display: flex;
  flex-direction: column;

  ${responsive.beforeTablet} {
    margin: ${sp(1)};
  }
`;
